import { useEffect, useState } from "react";
import { AsideAdminComponent } from "../layout/aside-admin";
import { pageIndicator } from "../apollo";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  ComponentTabLink,
  ITabLink,
  ITabTitle,
  PageType,
} from "../components/component-tab";
import { TableError } from "../components/table-error";
import { PaginationComponent } from "../components/pagination";
import { useListStaffUser } from "../hooks/useListStaffUser";
import { useDelUser } from "../hooks/useDelUser";
import { UserRole, WorkerType } from "../generated/graphql";

const RoleLabel: Record<UserRole, string> = {
  [UserRole.Admin]: "관리자",
  [UserRole.Worker]: "직원",
  [UserRole.General]: "일반",
};

const WorkerTypeLabel: Record<WorkerType, string> = {
  [WorkerType.Driver]: "기사",
  [WorkerType.Packer]: "패커",
  [WorkerType.Pilot]: "조종사",
};

export const AdminListAccount = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [page, setPage] = useState<number>(1);

  const tabList: ITabLink[] = [];
  const stitle: ITabTitle = { text: "계정 관리" };
  const word = "계정";

  const [listStaffUser, { data, loading, refetch }] = useListStaffUser();
  const listStaffUserHandler = (page: number | null) => {
    listStaffUser({ variables: { input: { ...(page && { page: +page }) } } });
  };

  const onDelCompleted = async (data: any) => {
    const {
      delUser: { ok, err },
    } = data;
    if (ok) {
      await refetch();
    } else {
      alert(err);
    }
  };
  const [delUser, { loading: delUserLoading }] = useDelUser(onDelCompleted);
  const delUserHandler = (userId: number) => {
    if (delUserLoading) return;
    if (
      window.confirm(
        "삭제한 계정은 복구할 수 없습니다. 정말로 삭제하시겠습니까?"
      )
    ) {
      delUser({ variables: { input: { id: userId } } });
    }
  };

  // --- Page ---
  const pageHandler = (page: number) => {
    setPage(page);
    navigate({
      pathname: "/account",
      search: `?page=${page}`,
    });
    listStaffUserHandler(page);
  };

  useEffect(() => {
    pageIndicator("account");
    setPage(
      location.search.split("page=").length > 1
        ? +location.search.split("page=")[1].split("&")[0]
        : 1
    );
    listStaffUserHandler(page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="bg-main bg-opacity-50 w-full h-full min-h-screen">
      <div className="w-full mx-auto h-full min-h-screen bg-gray-100">
        <main id="main">
          <div className="grid grid-cols-[200px_1fr] max-w-full">
            <AsideAdminComponent />
            <div className="mypages bg-gray-100 w-full min-w-[1200px] overflow-hidden">
              <div className="orderWrap">
                <div className="h-fix-content relative">
                  <div className={`w-full h-full px-10 py-8`}>
                    <ComponentTabLink
                      tabs={tabList}
                      stitle={stitle}
                      type={PageType.Account}
                    />
                    {/* 목록 */}
                    <div className=" shadow-lg h-[800px] h-fix-content w-full overflow-auto bg-white">
                      <table className="align-center w-[1200px] text-sm border-[#F9F8F9] ">
                        <colgroup>
                          <col width="64" />
                          <col width="168" />
                          <col width="168" />
                          <col width="88" />
                          <col width="88" />
                          <col />
                          <col width="128" />
                        </colgroup>
                        <thead>
                          <tr className="border-b border-[#F9F8F9] h-8">
                            <th className="text-[#8B8C8C]">no</th>
                            <th className="text-[#8B8C8C]">계정(아이디)</th>
                            <th className="text-[#8B8C8C]">이름</th>
                            <th className="text-[#8B8C8C]">권한</th>
                            <th className="text-[#8B8C8C]">직군</th>
                            <th className="text-[#8B8C8C]">배정 서비스</th>
                            <th className="text-[#8B8C8C]">기능</th>
                          </tr>
                        </thead>
                        <tbody>
                          {!loading &&
                            data?.listStaffUser.users &&
                            data.listStaffUser.users.map((user, index) => (
                              <tr
                                className="border-b border-[#F9F8F9] h-[68px]"
                                key={`staff-user-${user.id}`}
                              >
                                <td className="table-text">{index + 1}</td>
                                <td className="table-text">
                                  <Link
                                    to={`/account/update/${user.id}`}
                                    className={`cursor-pointer`}
                                  >
                                    {user.username}
                                  </Link>
                                </td>
                                <td className="table-text">{user.name}</td>
                                <td className="table-text">
                                  {RoleLabel[user.role]}
                                </td>
                                <td className="table-text">
                                  {user.workerType
                                    ? WorkerTypeLabel[user.workerType]
                                    : ""}
                                </td>
                                <td className="table-text">
                                  {user.linkServices &&
                                  user.linkServices.length > 0
                                    ? user.linkServices
                                        .map((service) => service.name)
                                        .join(", ")
                                    : "전체(수퍼관리자)"}
                                </td>
                                <td className="table-text py-1">
                                  <Link
                                    to={`/account/update/${user.id}`}
                                    className="inline-block bg-[#CCCCCC]
                                    rounded-lg py-[6px] px-[3px] w-[48px] h-7 text-xs text-white"
                                  >
                                    편집
                                  </Link>
                                  <button
                                    className="bg-[#CCCCCC] rounded-lg py-[6px]  w-[48px] h-7 ml-4 text-white"
                                    onClick={() => delUserHandler(user.id)}
                                  >
                                    삭제
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                      {loading && (
                        <TableError errorMessage={`정보를 불러오는중입니다`} />
                      )}
                      {!loading &&
                        data?.listStaffUser.users &&
                        data.listStaffUser.users.length < 1 && (
                          <TableError
                            errorMessage={`${word} 정보가 없습니다`}
                          />
                        )}

                      {!loading &&
                        data?.listStaffUser.users &&
                        data.listStaffUser.users.length > 0 && (
                          <PaginationComponent
                            page={page}
                            totalPages={Number(data.listStaffUser.totalPages)}
                            totalResults={Number(
                              data.listStaffUser.totalResults
                            )}
                            pageHandler={pageHandler}
                          />
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};
